module.exports = __webpack_public_path__ + "static/media/Vectorlogout.90720a06.svg";